/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateManagementModalContainer as TemplateManagementModal } from './TemplateManagementModal.container';
